import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { IImbpSmartMeterInterest } from "@/models/imbpSmartMeterInterest/imbpSmartMeterInterest.types"
import { AccountService } from "@/services/AccountService"
import { ImbpService } from "@/services/ImbpService"

export const getImbpSmartMeterInterest = (accountNumber: string) => {
  const queries = new QueryAggregator()

  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  queries.add(coreIdQuery)

  let imbpSmartMeterInterest: IImbpSmartMeterInterest | null = null

  if (coreIdQuery.data) {
    const imbpSmartMeterInterestQuery =
      ImbpService.getRegisteredSmartMeterInterest(coreIdQuery.data)

    imbpSmartMeterInterest = imbpSmartMeterInterestQuery.data
    queries.add(imbpSmartMeterInterestQuery)
  }

  return queries.setData(imbpSmartMeterInterest).getAggregate()
}
